/**
 * Sort model shared by the Headless 2 surfaces (@coveo/atomic-react: publisher
 * profiles, merch blocks) and SearchV2 (Headless 3 via
 * @coveo/headless-react/ssr). Pure data and pure helpers only — no Coveo
 * imports — so both build their criteria from one table and cannot drift on
 * option values, field names, orders, or ranking-context semantics.
 *
 * `relevance`, `popularity` and `rating` all sort by the relevance criterion;
 * the pipeline's ranking Conditions tell them apart via the boolean context
 * flags keyed below, not via the sort expression.
 */

export const RELEVANCE_SORT_VALUE = 'relevance';
export const POPULARITY_SORT_VALUE = 'popularity';
export const RATING_SORT_VALUE = 'rating';

export const POPULARITY_CONTEXT_KEY = 'popularity';
export const RATING_CONTEXT_KEY = 'rating';

export type SortFieldData = {
  value: string;
  field: string;
  order: 'ascending' | 'descending';
};

export const FIELD_SORT_DATA: SortFieldData[] = [
  {
    value: 'published-date',
    field: 'first_published_at',
    order: 'descending',
  },
  {
    value: 'recently-updated',
    field: 'last_published_at',
    order: 'descending',
  },
  {
    value: 'price-low-to-high',
    field: 'ec_price_filter',
    order: 'ascending',
  },
  {
    value: 'price-high-to-low',
    field: 'ec_price_filter',
    order: 'descending',
  },
];

/**
 * Relevance, popularity and rating all sort by relevancy, so the sort criterion
 * alone cannot tell them apart. The ranking context is what distinguishes them
 * and it lives on the engine, making it the source of truth every mounted sort
 * control can agree on.
 */
export const getSortValueForRankingContext = (
  contextValues: Record<string, unknown> | undefined,
  fallbackValue: string
): string => {
  if (contextValues?.[RATING_CONTEXT_KEY]) return RATING_SORT_VALUE;
  if (contextValues?.[POPULARITY_CONTEXT_KEY]) return POPULARITY_SORT_VALUE;
  return fallbackValue;
};
